import { Link } from "react-router-dom";
import { Instagram, Facebook, Phone, Mail } from "lucide-react";
import { useSettings } from "@/components/public/shared";

const LOGO = "https://customer-assets-jt897jd0.emergentagent.net/job_ethical-dining-group/artifacts/7u0c32b4_WhatsApp%20Image%202026-08-20%20at%2012.46.59%20PM.jpeg";

function Col({ title, children }) {
  return (
    <div>
      <h4 className="font-display text-2xl font-normal text-gold">{title}</h4>
      <ul className="mt-5 space-y-3 text-sm text-ivory/70">{children}</ul>
    </div>
  );
}
function Item({ to, children }) {
  return <li><Link to={to} className="flex items-center gap-2 hover:text-gold"><span className="h-px w-3 bg-gold/60" />{children}</Link></li>;
}

export default function Footer() {
  const s = useSettings();
  const wa = `https://wa.me/${(s.whatsapp_number || "919884272560").replace(/\D/g, "")}`;
  return (
    <footer className="relative overflow-hidden bg-charcoal text-ivory">
      <div className="hairline-gold" />
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-3 lg:grid-cols-5">
          <div className="col-span-2 md:col-span-3 lg:col-span-1">
            <span className="inline-block rounded-md bg-white px-3 py-2 ring-1 ring-gold/30">
              <img src={s.logo_url || LOGO} alt="Mee2Momos — Pure Veg & Jain-Friendly Foods" className="h-14 w-auto object-contain" />
            </span>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-ivory/60">Crafting Experiences. Serving Excellence. Premium pure vegetarian &amp; Jain-Friendly catering, food services and hospitality.</p>
            <div className="mt-6 flex gap-3">
              <a href="#" aria-label="Instagram" className="grid h-9 w-9 place-items-center rounded-full border border-ivory/20 hover:border-gold hover:text-gold transition-colors"><Instagram className="h-4 w-4" /></a>
              <a href="#" aria-label="Facebook" className="grid h-9 w-9 place-items-center rounded-full border border-ivory/20 hover:border-gold hover:text-gold transition-colors"><Facebook className="h-4 w-4" /></a>
              <a href={wa} target="_blank" rel="noreferrer" aria-label="WhatsApp" className="grid h-9 w-9 place-items-center rounded-full border border-ivory/20 hover:border-[#25D366] hover:text-[#25D366] transition-colors"><i className="fa-brands fa-whatsapp text-base" /></a>
            </div>
          </div>

          <Col title="About Us">
            <Item to="/about">Our Story</Item>
            <Item to="/about">Our Philosophy</Item>
            <Item to="/about">Vision &amp; Mission</Item>
            <Item to="/about">Our Values</Item>
          </Col>

          <Col title="Experiences">
            <Item to="/catering">Event Catering</Item>
            <Item to="/food-services">Bulk &amp; Food Services</Item>
            <Item to="/events">Events &amp; Experiences</Item>
            <Item to="/hospitality">Hospitality Services</Item>
          </Col>

          <Col title="Discover">
            <Item to="/menu">Our Menu</Item>
            <Item to="/packages">Menu Packages</Item>
            <Item to="/gallery">Gallery</Item>
            <Item to="/contact">Contact Us</Item>
            <li><a href={s.zomato_url || "#"} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-gold"><span className="h-px w-3 bg-gold/60" />Order Online</a></li>
          </Col>

          <Col title="Contact">
            <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-gold" /><a href={`tel:${(s.company_phone || "").replace(/\s/g, "")}`} className="hover:text-gold" data-testid="footer-phone">{s.company_phone}</a></li>
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-gold" /><a href={`mailto:${s.company_email}`} className="hover:text-gold">{s.company_email}</a></li>
            <li className="flex items-center gap-2"><i className="fa-brands fa-whatsapp text-base text-[#25D366]" /><a href={wa} target="_blank" rel="noreferrer" className="hover:text-gold" data-testid="footer-whatsapp">WhatsApp Us</a></li>
            <Item to="/privacy">Privacy Policy</Item>
            <Item to="/terms">Terms &amp; Conditions</Item>
          </Col>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-ivory/10 pt-8 text-xs text-ivory/50 md:flex-row">
          <p>© {new Date().getFullYear()} Mee2Momos Hospitality. All rights reserved.</p>
          <p>Pure Veg &amp; Jain-Friendly · Chinese · Thai · Japanese · Italian · Mexican · European</p>
        </div>
      </div>
    </footer>
  );
}
